import React from 'react'
import CarBarner from '../../components/web/cars/CarBarner'
import CarListFilterList from '../../components/web/cars/CarListFilterList'

const CariLstPage = () => {
  return (
    <div className="page-content" style={{ background: "#F5FDF7" }}>

      {/*<CarBarner /> */}
      <CarListFilterList />

    </div>
  )
}

export default CariLstPage
